import { render } from "./WCAddToListModal.vue?vue&type=template&id=6f04028a"
import script from "./WCAddToListModal.vue?vue&type=script&lang=js"
export * from "./WCAddToListModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__